module.exports = __webpack_public_path__ + "assets/img/appditto-logo.93b4f726844c8517083dce97598560c2.svg";